import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi'
import OwlCarousel from 'react-owl-carousel'

function Testimonial() {
    const {data :{home: {testimonial : {data,name}}},isLoading} = useGetSettingQuery()

    return ( 
        <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s" id='testimonial'>
            <div className="container">
                <div className="section-title text-center">
                    <h1 className="display-5 mb-5">{name}</h1>
                </div>
                {!isLoading && <OwlCarousel className="testimonial-carousel" loop nav={true} dots={false} center={true} 
                    autoplay={true} smartSpeed={1000} 
                    navText={[
                        '<i class="fas fa-arrow-left"></i>',
                        '<i class="fas fa-arrow-right"></i>'
                    ]} responsive={
                        {
                            0:{
                                items:1
                            },
                            768:{
                                items:2
                            }
                        }
                    }>
                    {data.lso_comments && data.lso_comments.map((row,index) => 
                    <div className="testimonial-item text-center" key={index}>
                        <img className="img-fluid bg-light p-2 mx-auto mb-3" alt={row.txt_name} src={row.img_profile} style={{width: "90px", height: "90px"}}/>
                        <div className="testimonial-text text-center p-4">
                            <p>{row.txe_comment}</p>
                            <h5 className="mb-1">{row.txt_name}</h5>
                            <span className="fst-italic">{row.txt_career}</span>
                        </div>
                    </div>)}
                </OwlCarousel>}
            </div>
        </div>
     );
}

export default Testimonial;